import React,{useEffect, useRef} from 'react'
import "./About.css"
import {profile2} from '../../images'
import gsap from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'


const About = () => {
  const container = useRef(null);
  //Register plugin
  gsap.registerPlugin(ScrollTrigger);
  useEffect(()=>{
    const el = container.current;
    gsap.fromTo('.about__container',{
      scale:0.7,
    },
    {
      scale:1,
      scrollTrigger:{
        trigger:el,
        scrub:true,
        markers:false,
      }
    }
  )
  },[])
  




  return (
    <section ref={container} id='about'>
      <div className="section__wrapper about__container">
          <div className="me__container blur-effect">
              <div className="photo__container">
                 <img src={profile2} alt="" />
              </div>
          </div>
          <div className="section__header">
              <h4 className='primary__title'>ABOUT ME</h4>
              <h1 className='title'>I am <span className='color__primary'>Natsuki Subaru</span></h1>
              <p className="text__muted description">
                I'm a Kind and empathetic: Cares for others and seeks to help them, an ordinary high school student before being suddenly summoned to another world known as Lugnica. After dying upon his arrival, he discovers his Return by Death ability and begins a journey to protect his newfound friends and prevent tragedy....
               <br />
               <br />
                A 17-year-old high school student who is transported to another world, Lugunica. Initially, he is unaware of his abilities and relies on his wit to survive. Forms a close bond with Emilia, a half-elf who is a candidate for the throne of Lugunica. Must overcome his own flaws and use his abilities to protect the people he cares about from various threats.
               <br />
               <br />
               Personality ; Subaru is initially a lazy and self-centered teenager. However, after being transported to another world and experiencing repeated deaths, he becomes more determined and compassionate. He is willing to sacrifice himself for others and to fight for what he believes in.
               <br />
               <br />
              </p>
              <a href="https://telegram.me/cosmic_freak/3" className="btn btn__primary">Read more</a>
          </div>
      </div>
    </section>
  )
}

export default About
